import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import TweenMax from './../vendors/TweenMax';

class templateLayouts {
  constructor() {
    this.videoContainer = $('.marketingHeader');
    this.arrow = $('.marketingHeader__arrow i');
    this.arrowPosition = $('.marketingTemplateIntro');
    this.events();
  }

  events() {
    let vm = this;
    $(vm.arrow).on('click', function () {
      let videoId = $(this).attr('data-video');
      vm.scrollBottom(vm.videoContainer);
    });

    this.headerArrow();

    // this.animateLayout1();
    // this.animateLayout2();
    // this.animateLayout3();
  }

  headerArrow() {
    this.arrowPosition.prepend(`
      <div class="marketingHeader__arrow">
        <i class="fal fa-chevron-down" aria-label="scroll down" tabindex="0" role="button"></i>
      </div>
    `);
  }

  scrollBottom(id) {
    $('html, body').animate(
      {
        scrollTop: $(id).prop('scrollHeight'),
      },
      1000
    );
  }

  // animateLayout1() {
  // }
  // animateLayout2() {
  //   let scrollMagicController = new ScrollMagic.Controller();

  //   if ($('.marketingTemplateLayout2__background').length) {
  //     let scale_tween = TweenMax.from('.marketingTemplateLayout2__background', 1, {
  //       transform: 'translateY(-60px)',
  //       ease: Linear.easeInOut
  //     });
  //     let scene = new ScrollMagic.Scene({
  //         triggerElement: ".marketingTemplateLayout2"
  //       })
  //       .setTween(scale_tween)
  //       .addTo(scrollMagicController);
  //   }
  // }
  // animateLayout3() {
  //   let scrollMagicController = new ScrollMagic.Controller();

  //   if ($('.top.svg svg').length) {
  //     let scale_tween = TweenMax.from('.top.svg svg', 1, {
  //       // transform: 'scale(.90)',
  //       'margin-left': '-50px',
  //       // opacity: 0.5,
  //       ease: Linear.easeIn
  //     });
  //     let scene = new ScrollMagic.Scene({
  //         triggerElement: ".marketingTemplateLayout3"
  //       })
  //       .setTween(scale_tween)
  //       .addTo(scrollMagicController);
  //   }

  //   if ($('.marketingTemplateLayout3__right').length) {
  //     let scale_tween = TweenMax.from('.marketingTemplateLayout3__right', 1, {
  //       transform: 'translate(60px,-40px)',
  //       opacity: 0.8,
  //       ease: Linear.easeInOut
  //     });
  //     let scene = new ScrollMagic.Scene({
  //         duration: 500,
  //         triggerElement: ".marketingTemplateLayout3"
  //       })
  //       .setTween(scale_tween)
  //       .addTo(scrollMagicController);
  //   }

  //   if ($('.marketingTemplateLayout3__header_titleWrapper').length) {
  //     let scale_tween = TweenMax.from('.marketingTemplateLayout3__header_titleWrapper', 1, {
  //       'margin-bottom': '-50px',
  //       ease: Linear.easeOut
  //     });
  //     let scene = new ScrollMagic.Scene({
  //         duration: 300,
  //         triggerElement: ".marketingTemplateLayout3"
  //       })
  //       .setTween(scale_tween)
  //       .addTo(scrollMagicController);
  //   }

  // }
}

export default templateLayouts;
